export default __webpack_public_path__ + "static/media/Bohubrihi Web Development.4567952a.webp";